import { CommonModule } from '@angular/common';
import { Component, inject, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ProjectInfrastructureService } from '@app/shared/services/project-infrastructure.service';
import { Project } from 'lfx-pcc';
import { PrimeNG } from 'primeng/config';
import { SkeletonModule } from 'primeng/skeleton';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'lfx-calendar',
  standalone: true,
  imports: [FormsModule, CommonModule, SkeletonModule, DatePickerModule],
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss',
})
export class CalendarComponent {
  public project: WritableSignal<Partial<Project>>;
  public date: WritableSignal<Date>;

  private itxService: ProjectInfrastructureService = inject(ProjectInfrastructureService);
  private config: PrimeNG = inject(PrimeNG);

  public constructor() {
    this.project = this.itxService.project;
    this.date = this.itxService.date;
  }

  public onChange(event: Date) {
    this.itxService.setDate(event);

    this.config.setTranslation({
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    });
  }
}
